// extracted by mini-css-extract-plugin
export default {"modal":"AU-z","error":"BU-z","disabled":"CU-z","fields":"DU-z","errorMsg":"EU-z","footer":"FU-z","formContentWrapper":"GU-z","productImage":"HU-z","overlay":"IU-z"};